const search = [
    { title: "StockIT", category: "Project" },
    { title: "TakeNote", category: "Project" },
    { title: "TaRct", category: "Project" },
    { title: "To Do", category: "Project" },
    { title: "ArchiTect", category: "Project" },
    { title: "WeatherLy", category: "Project" },
    {title: "Jane Cooper", category:"@JaneCooper" },
    {title: "Ariene McCoy", category:  "@ArieneMcCoy" },
    {title: "Theresa Webb", category: "@TheresaWebb" },
    {title: "Ralph Edwards", category: "@RalphEdwards" },
    {title: "Raplhie", category: "@Raplhie" }
      
];
export default search